import { cn } from "@/lib/utils";
import { FLUID_CDN_URL } from "@/lib/constants";
import { normalizeCardBrand } from "@/lib/payment-method-display";
import FluidImage from "../images/fluid-image";

const cardIcons = {
  visa: {
    src: `${FLUID_CDN_URL}/images/checkout/icons/Visa.png`,
    alt: "visa",
  },
  mastercard: {
    src: `${FLUID_CDN_URL}/images/checkout/icons/Mastercard.png`,
    alt: "mastercard",
  },
  amex: {
    src: `${FLUID_CDN_URL}/images/checkout/icons/Amex.png`,
    alt: "amex",
  },
  discover: {
    src: `${FLUID_CDN_URL}/images/payment_icons/discover.svg`,
    alt: "discover",
  },
} as const;

type CardIconKey = keyof typeof cardIcons;

function isCardIconKey(value: string): value is CardIconKey {
  return value in cardIcons;
}

export default function CreditCardIcons({
  cardType,
  containerStyles,
}: {
  cardType: string | undefined;
  containerStyles?: string;
}) {
  if (!cardType) {
    return (
      <div className={cn("flex flex-row space-x-1", containerStyles)}>
        {Object.values(cardIcons).map((icon) => (
          <FluidImage
            key={icon.alt}
            src={icon.src}
            alt={icon.alt}
            width={30}
            height={30}
            className="object-contain"
          />
        ))}
      </div>
    );
  }

  const normalizedCardType =
    normalizeCardBrand(cardType) ?? cardType.toLowerCase();
  const selectedIcon = isCardIconKey(normalizedCardType)
    ? cardIcons[normalizedCardType]
    : null;
  return selectedIcon ? (
    <div className={cn("flex flex-row space-x-1", containerStyles)}>
      <FluidImage
        src={selectedIcon.src}
        alt={selectedIcon.alt}
        width={30}
        height={30}
      />
    </div>
  ) : null;
}
